<template>
  <div class="layout-column md:layout-row w-full justify-between gap-md">
    <div class="layout-row gap-md">
      <template v-if="isMobile && !hideSidebar">
        <div class="layout-column">
          <OrIconButtonV3
            icon="view_sidebar"
            @click="openSidebar"
          />
        </div>
        <div class="w-[1px] h-lg bg-disabled" />
      </template>
      <div class="typography-headline-2 truncate text-on-surface dark:text-on-surface-dark">
        {{ title }}
      </div>
    </div>
    <div class="empty:hidden layout-row">
      <slot class="grow" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useEventBus } from '@vueuse/core';
import { useResponsive, OrIconButtonV3 } from '@onereach/ui-components';

defineProps<{
  title: string;
  hideSidebar?: boolean;
}>();

const { isMobile } = useResponsive();
const { emit } = useEventBus<boolean>('sidebar:open-drawer');
const openSidebar = () => emit(true);
</script>
